import Rollbar from 'rollbar'

type Configuration = Rollbar.Configuration

import { ENV } from '@/config'

const ROLLBAR_TOKEN =
  typeof window === 'undefined' ? process.env.ROLLBAR_SERVER_TOKEN : process.env.NEXT_PUBLIC_ROLLBAR_TOKEN

const regexesToIgnore = [
  /ResizeObserver loop limit exceeded/gi,
  /ResizeObserver loop completed with undelivered notifications/gi,
]

// For cases where Rollbar needs to be executed
// on development environment, set ROLLBAR_ENABLED to true or type "rollbar.configure({ enabled: true })"
// in your browser console.
const ROLLBAR_ENABLED = !!(ENV && !['development', 'test'].includes(ENV))
const config: Configuration = {
  enabled: ROLLBAR_ENABLED,
  accessToken: ROLLBAR_TOKEN,
  captureUncaught: true,
  captureUnhandledRejections: true,
  hostSafeList: ['neat.com'],
  checkIgnore: (isUncaught, args) => {
    const [message, err] = args
    let errorMessage
    let errorStack
    if (typeof err === 'string') {
      errorMessage = err
    } else if (err && 'message' in err) {
      errorMessage = err.message
      errorStack = err.stack
    }
    const messages = [message, errorMessage, errorStack]
    const shouldIgnore = !!(
      messages.some((v) => typeof v === 'string' && regexesToIgnore.some((regex) => regex.test(v))) && isUncaught
    )
    return shouldIgnore
  },
  payload: {
    environment: ENV,
    appBuild: process.env.NEXT_PUBLIC_BUILD_TAG,
    client: {
      javascript: {
        source_map_enabled: true,
        guess_uncaught_frames: true,
        code_version: process.env.NEXT_PUBLIC_BUILD_TAG,
      },
    },
  },
}

const Instance = Rollbar.init(config)

export const sendError = (error: unknown, message?: string, ...args: Rollbar.LogArgument[]) => {
  if (!ROLLBAR_ENABLED) return
  let errorArg
  if (error && typeof error === 'object' && 'message' in error) {
    errorArg = error
  }
  let messageArg = message
  if (!messageArg && typeof errorArg?.message === 'string') {
    messageArg = errorArg.message
  }

  Instance.error(messageArg, errorArg, ...args)
}

export const sendWarning = (error?: unknown, message?: string) => {
  if (!ROLLBAR_ENABLED) return
  let errorArg
  if (error && typeof error === 'object' && 'message' in error) {
    errorArg = error
  }
  let messageArg = message
  if (!messageArg && typeof errorArg?.message === 'string') {
    messageArg = errorArg.message
  }
  Instance.warning(messageArg, errorArg)
}

export default Instance
